import { authHeaders } from './auth';

const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';

export async function askSirus(messages, context = {}) {
  if (!WORKER_URL) return getDemoResponse(messages[messages.length-1]?.content||'', context);

  const response = await fetch(`${WORKER_URL}/api/chat`, {
    method:      'POST',
    headers:     { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body:        JSON.stringify({ messages, context }),
  });

  if (response.status === 401) throw new Error('401');
  if (!response.ok) {
    const e = await response.json().catch(()=>({}));
    throw new Error(e?.error || `HTTP ${response.status}`);
  }

  const data = await response.json();
  return data.text || 'Nessuna risposta.';
}

export function parseActions(text) {
  const actions = [];
  const re = /\[ACTION:(\w+):([^\]]+)\]/g;
  let m;
  while ((m = re.exec(text)) !== null)
    actions.push({ type: m[1], params: m[2].split(':') });
  return { clean: text.replace(/\[ACTION:[^\]]+\]/g, '').trim(), actions };
}

function getDemoResponse(input, ctx) {
  const l = input.toLowerCase();
  const norm = v => String(v || '').toLowerCase().replace(/[?.,;:!]+$/g, '').replace(/\s+/g, ' ').trim();
  const shopping = Array.isArray(ctx.shopping) ? ctx.shopping : [];
  const findItem = ref => shopping.find(i => norm(i.code) === norm(ref) || norm(i.name).includes(norm(ref)) || norm(ref).includes(norm(i.name)));
  const cleanInput = input.replace(/[?.,;:!]+$/g, '');
  const supplierMatch = cleanInput.match(/(?:da|dal|fornitore|ordine|comprare da|compro da)\s+([a-z0-9\s._-]+)$/i);
  if (supplierMatch && /(cosa|lista|ordine|compra|manca|prendere|compro)/i.test(input)) {
    const supplier = supplierMatch[1].trim();
    const rows = shopping.filter(i => {
      const s = norm(i.supplier);
      const q = norm(supplier);
      return s && (s === q || s.includes(q) || q.includes(s));
    });
    if (!rows.length) return 'Nessun prodotto trovato per questo fornitore.';
    return `ORDINE FORNITORE: ${rows[0].supplier || supplier}\n\nCodice | Prodotto | Quantità | Note\n${rows.map(i => `${i.code || ''} | ${i.name} | ${i.qty || ''} | ${i.destination || ''}`).join('\n')}`;
  }
  const codeMatch = input.match(/codice\s+([a-z0-9._-]+)/i);
  if (codeMatch && /(cosa|che|prodotto)/i.test(input)) {
    const item = findItem(codeMatch[1]);
    return item ? `Codice ${item.code || codeMatch[1]}:\nProdotto: ${item.name}\nFornitore: ${item.supplier || 'Fornitore non presente.'}` : 'Nessun prodotto trovato per questo codice.';
  }
  if (l.includes('calendario') || l.includes('oggi'))
    return ctx.events?.length ? `Hai ${ctx.events.length} impegni oggi.` : 'Nessun evento oggi.';
  if (l.includes('task')) return `${ctx.tasks?.filter(t=>!t.done).length||0} task attive.`;
  if (l.includes('spesa') || l.includes('shopping'))
    return `Lista spesa: ${shopping.map(i=>`${i.code ? i.code + ' - ' : ''}${i.name}${i.supplier ? ' (' + i.supplier + ')' : ''}`).join(', ')||'vuota'}.`;
  return '[DEMO] Configura REACT_APP_WORKER_URL nel .env.';
}
